module.exports = __webpack_public_path__ + "static/orthoType_table_desktop-15eea9505e9ebdbc7c0fe75849651244.png";